jQuery(document).ready(function($) {
    
    $( '.custom-slider-arrow' ).on( 'click', function() {
        const $slider = $( this ).closest('section').find( '.slick-slider' );
        if ( $( this ).hasClass( 'slider-arrow-prev' ) ) {
            $slider.slick( 'slickPrev' );
        } else {
            $slider.slick( 'slickNext' );
        }
    });
    
});